module.exports = new Promise((resolve, reject) => {
        Promise.resolve(window.__mf_remotes_map__ || {})
        .then((remotesMap) => {
            if (!remotesMap['webdebug']) {
                const staticUrl = window._endpoints['webdebug'] + '/remoteEntry.js';
                if (undefined) {
                    console.warn('MF: [webdebug] remote url not found in config map, fallback to ' + staticUrl);
                }
                return staticUrl;
            }
            return remotesMap['webdebug'] + '/remoteEntry.js';
        })
        .then((remoteEntryUrl) => {
            return new Promise((_resolve, _reject) => {
                if (typeof webdebug !== 'undefined') {
                    return _resolve();
                }
                __webpack_require__.l(
                    remoteEntryUrl,
                    function(event) {
                        if (typeof webdebug !== 'undefined') {
                            return _resolve();
                        }
                        var scriptSrc = event && event.target && event.target.src;
                        var _error = new Error('Load script failed: ' + scriptSrc);
                        _error.name = 'ScriptExternalLoadError';
                        _error.request = scriptSrc;
                        _reject(_error);
                    },
                    'webdebug',
                );
            });
        })
        .then(() =>
            resolve({
                get: async (moduleRequest) => {
                    // Allow import non-existing module path .eg ./exposes/non-existing-path.
                    // If there is error in .get(moduleRequest), return empty module in its place
                    // and log the error in console.

                    // fallback module getter, returning empty module
                    let getter = () => ({ __esModule: true });
                    try {
                        getter = await webdebug.get(moduleRequest);
                    } catch (err) {
                        console.error('Error loading module from webdebug:', err.message, 'Providing fallback empty module.');
                    }
                    const moduleResult = getter();
                    return () => moduleResult;
                },
                init: (sharedScope) => {
                    
                    try {
                        return webdebug.init(sharedScope);
                    } catch (e) {
                        console.log('remote container [webdebug] already initialized');
                    }
                },
            })
        )
        .catch((err) => {
            console.warn(err);
            reject(err);
        });
    });